import React from 'react';
import _ from 'lodash';
import Paragraph from './Paragraph';
import Link from '../Link/Link'
import RichText from '../RichText';
import { useTranslation } from 'react-i18next';



const ContactBlocks = ({ entity }) => {

  const { t } = useTranslation();

  return (
    <div className="contact-cards">
      {entity.fieldItems.map(card => {
        const icon = _.get(card, 'entity.fieldIcon.entity.fieldMediaIcon.entity.uri.url');
        const title = _.get(card, 'entity.fieldTitle');
        const body = _.get(card, 'entity.fieldBody.processed')
        const moreLink = _.get(card, 'entity.fieldMoreLink');
        const moreLinkLabel= _.get(entity, 'fieldMoreLinkLabel', null);

        return (
          <div className="contact-card" key={card.entity.entityId}>
            <div className="cardTitle">
              {icon && <img src={icon} alt={title}/>}
              <h2>{title}</h2>
            </div>
            <RichText body={body} />
            {moreLink && (
              <Link type="arrow" href={_.get(moreLink, 'url.path')} label={moreLinkLabel} aria-label={t('read_more_about', { title })}>
                {_.get(moreLink, 'title', 'Meer informatie')}
              </Link>
            )}
          </div>
        )})}
    </div>
  );
}
export default ContactBlocks;
